//-----------------------------|| DETAILS ||---------------------------------------------------------------
export const SET_DOWNLOAD_APK_SUCCESS = 'SET_DOWNLOAD_APK_SUCCESS';
export const CLEAR_DOWNLOAD_APK = 'CLEAR_DOWNLOAD_APK';
export const DOWNLOAD_APK_PENDING = 'DOWNLOAD_APK_PENDING';
export const DOWNLOAD_APK_ERROR = 'DOWNLOAD_APK_ERROR';
export const DOWNLOAD_APK_ERROR_CLEAR = 'DOWNLOAD_APK_ERROR_CLEAR';

